import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../Confirmation'
import { InputField } from '../../Input'
import {
  GRETA_CHAT_TITLE_MAX_LENGTH,
  QA_NAME_GRETA_AI_CHAT_RENAME_INPUT,
} from '../GretaAIChat.constants'

function GretaAIChatRenameModal({ chat, onCancel, onSubmit }) {
  const { t } = useTranslation()

  const currentTitle = chat.title || t('Greta.NewChatKey')

  const [name, setName] = useState(currentTitle)
  const [error, setError] = useState(null)

  const trimmedName = name.trim()
  const isSaveDisabled =
    trimmedName.length === 0 || trimmedName === currentTitle.trim()

  function handleChange(event) {
    setName(event.target.value)
    setError(null)
  }

  async function handleSubmit() {
    setError(null)

    try {
      await onSubmit(trimmedName)
    } catch {
      setError(t('Greta.StatusErrorKey'))
    }
  }

  return (
    <ConfirmationModal
      Description={null}
      actionButtonsProps={{
        submitProps: { disabled: isSaveDisabled },
        submitText: t('Greta.SaveButtonKey'),
      }}
      title={t('Greta.RenameChatTitleKey')}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    >
      <InputField
        forceFocus
        errorText={error}
        maxLength={GRETA_CHAT_TITLE_MAX_LENGTH}
        placeholder={t('Greta.ChatNamePlaceholderKey')}
        qaName={QA_NAME_GRETA_AI_CHAT_RENAME_INPUT}
        value={name}
        onChange={handleChange}
      />
    </ConfirmationModal>
  )
}

export default GretaAIChatRenameModal
